import { BaseService } from './base.service';
import { IBaseListingModel, BaseListingModel } from '../models/base-listing.model';
import { Uris } from '../common/constants';

export interface ITenantService {
  getTenants(param: any, allowPagination?: boolean): Promise<any>;
  getTenantsForTicket(param: any): Promise<any>;
  getBlockTenants(blockId: string, param: any): Promise<any>;
  getBlockTenantById(blockId: string, tenantId: string): Promise<any>
  getTenantById(tenantId: string);
}

export class TenantService extends BaseService {

  /**
   *
   */
  constructor() {
    super('tenant');
  }

  getTenants(param: any, allowPagination?: boolean): Promise<any> {
    return super.get(Uris.Search, { entity: 'tenant' })
      .then((response: IBaseListingModel<any>) => {
        if (allowPagination) {
          return Promise.resolve(new BaseListingModel<any>(response))
        }
        else return Promise.resolve(response.data);
      })
      .catch(error => console.log(error))
  }

  getTenantsForTicket(param: any): Promise<any> {
    return super.get(Uris.Search, { entity: 'tenant' })
      .then((response: any) => {
        return Promise.resolve((response || []));
      })
      .catch(error => console.log(error))
  }
  getBlockTenants(blockId: string, param: any): Promise<any> {
    return super.get(Uris.BlockTenants.replace(':id', blockId), param)
      .then((response: IBaseListingModel<any>) => response)
      .catch(error => console.log(error))
  }
  getBlockTenantById(blockId: string, tenantId: string) {
    return super.get(Uris.BlockTenantId.replace(':id', blockId).replace(':cid', tenantId))
      .then((response: IBaseListingModel<any>) => response)
      .catch(error => console.log(error))
  }
  getTenantById(tenantId: string) {
    return super.get(Uris.TenantId.replace(':id', tenantId))
  }
  *mapTenantObjectForTicket(tenant: any) {
    yield tenant.entity;
  }
}


// WEBPACK FOOTER //
// ./src/services/tenant.service.ts